import { Navigate, Route, Routes, useLocation } from 'react-router-dom'
import { useMe } from './api/hooks'
import { AppHeader } from './components/AppHeader'
import { ErrorBoundary } from './components/ErrorBoundary'
import { Toasts } from './components/Toasts'
import { Activity } from './pages/Activity'
import { Dashboard } from './pages/Dashboard'
import { Editor } from './pages/Editor'
import { Jobs } from './pages/Jobs'
import { Login } from './pages/Login'
import { Settings } from './pages/Settings'

export function App() {
  const me = useMe()
  const location = useLocation()

  if (me.isLoading) {
    return (
      <div className="flex h-screen items-center justify-center text-sm text-ink-600">
        Loading loco…
      </div>
    )
  }

  if (!me.data) {
    return (
      <>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="*"
            element={<Navigate to="/login" replace state={{ from: location.pathname }} />}
          />
        </Routes>
        <Toasts />
      </>
    )
  }

  return (
    <div className="flex h-screen flex-col overflow-hidden">
      <AppHeader me={me.data} />
      <main className="min-h-0 flex-1 overflow-hidden">
        <ErrorBoundary>
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/p/:platform/:project" element={<Editor />} />
            <Route path="/jobs" element={<Jobs />} />
            <Route path="/activity" element={<Activity />} />
            {/* Settings gates admin-only itself (see Settings.tsx) so a direct
                URL hit by an editor renders a clean "not permitted" state
                rather than depending on the route table to know the role. */}
            <Route path="/settings/*" element={<Settings />} />
            <Route path="/login" element={<Navigate to="/" replace />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </ErrorBoundary>
      </main>
      <Toasts />
    </div>
  )
}
